// extracted by mini-css-extract-plugin
export default {"cardBodyWrapper":"ButtonFontCard_cardBodyWrapper__xGwZN","text":"ButtonFontCard_text__JF4l3","row":"ButtonFontCard_row__M-O3I"};